import { DEFAULT_PAGE_INDEX, DEFAULT_PAGE_SIZE } from "constants/index";

import React, { FC, ForwardedRef, useEffect, useState } from "react";

import AutocompleteHookForm from "components/Autocomplete/Autocomplete.hookform";
import { MultiAutocompleteHookForm } from "components/MultiAutocomplete";
import { UserEntity, useGetManyBaseUserControllerUserEntity } from "generated";
import { useDebounce } from "hooks/useDebounce";

export interface SelectProps {
  name: string;
  label: string;
  multi?: boolean;
  require?: boolean;
  valueSelected?: string;
  disabled?: boolean;
  placeholder?: string;
  onChange?: (value: any) => void;
  defaultValue?: any;
}

type CandidateSelectProps = SelectProps;

const UserSelectForm: FC<CandidateSelectProps> = React.forwardRef<
  HTMLSelectElement,
  CandidateSelectProps
>((props: CandidateSelectProps, ref: ForwardedRef<HTMLSelectElement>) => {
  const {
    name,
    label,
    multi,
    require,
    valueSelected,
    disabled,
    placeholder,
    onChange,
    defaultValue,
  } = props;
  const [currentValue, setCurrentValue] =
    useState<{ label: string; value: any }[]>();
  const [keyword, setKeyword] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [listOptions, setListOptions] =
    useState<{ label: string; value: unknown }[]>();
  const { data, isLoading, error } = useGetManyBaseUserControllerUserEntity({
    s: JSON.stringify({
      ...(keyword
        ? {
            fullName: {
              $contL: keyword,
            },
          }
        : {}),
      // status: {
      //   $eq: "Active",
      // },
    }),
    limit: DEFAULT_PAGE_SIZE,
    offset: DEFAULT_PAGE_INDEX,
  });
  // debounce
  const debouncedSearchTerm = useDebounce(searchTerm, 300);
  useEffect(() => {
    setKeyword(debouncedSearchTerm);
  }, [debouncedSearchTerm]);

  const handleSearchSelection = (value: string) => {
    setSearchTerm(value);
  };
  const handleResetData = (dataQuery: UserEntity[]) => {
    let options: { label: string; value: string; email: string }[] = [];
    if (dataQuery && dataQuery.length > 0) {
      options = dataQuery.map((item) => ({
        value: item?.id ?? "",
        label: item?.fullName ?? "",
        email: item?.email ?? "",
      }));
    }
    setListOptions(options);
  };

  useEffect(() => {
    handleResetData(data?.data?.data ?? []);
  }, [data]);

  return multi ? (
    <MultiAutocompleteHookForm
      name={name}
      label={label}
      placeholder={placeholder ?? "Select an option"}
      options={listOptions ?? []}
      onInputChange={handleSearchSelection}
      required={require}
      disabled={disabled}
      onChange={onChange}
    />
  ) : (
    <AutocompleteHookForm
      name={name}
      label={label}
      placeholder={placeholder ?? "Select an option"}
      options={listOptions ?? []}
      onInputChange={handleSearchSelection}
      required={require}
      disabled={disabled}
      onChange={onChange}
    />
  );
});
export default UserSelectForm;
